<template>
    <div id="instructions1">
        <video id="my_video_1" class="video-js vjs-default-skin" width="640px" height="360px"
        controls preload="none" poster='https://vpremieretest.mobiotics.com/demoassets/entertainment.jpg'
        data-setup='{ "aspectRatio":"640:267", "playbackRates": [1, 1.5, 2] }'>
        <!-- <source src="https://vpremieretest.mobiotics.com/demoassets/Entertainment.mp4" type='video/mp4' /> -->
        <!-- <source src="https://d39a1jlfqg0udk.cloudfront.net/videos/1Plp2rrZ/nTHrY6EHQNqg_drm.mpd" type='application/dash+xml' /> -->
    </video>
    <!-- <video id="my_video_1" width=600 height=300 class="video-js vjs-default-skin" controls>
  <source src="https://d39a1jlfqg0udk.cloudfront.net/videos/1Plp2rrZ/nTHrY6EHQNqg_drm.mpd" type='application/dash+xml' />
</video> -->

  </div>
</template>

<style>
@import "https://vjs.zencdn.net/5-unsafe/video-js.css";
.video-js .vjs-big-play-button{
    top: 45%!important;
    left: 45%!important;
}
</style>

<script>


const videojs = require('video.js');
// const dash = require('dashjs');
// const videodash = require('videojs-contrib-dash');
export default {
    created(){
        // console.log('[videojs]'. videojs);

        // var player = videojs('my_video_1');
        //
        // console.log('[player]'. player);
        //
        // player.ready(function() {
        //     console.log('player ready');
        //     //   player.src({
        //     //     src: 'https://d39a1jlfqg0udk.cloudfront.net/videos/1Plp2rrZ/nTHrY6EHQNqg_drm.mpd',
        //     //     type: 'application/dash+xml'
        //     //   });
        //     //
        //     //   player.play();
        // });

    }
}


// // const { videojs } = require('../assets/js/Video.js');
// const videojs = require('video.js');
// // const { dash } = require('../assets/js/dashall.js');
// // const { videodash } = require('../assets/js/videodash.js');
//
//   import countTo from 'vue-count-to';
//   export default {
//     components: { countTo },
//     created(){
//         console.log('[videojs]'. videojs);
//
//         var player = videojs('my_video_1');
//
//         console.log('[player]'. player);
//
//         player.ready(function() {
//             console.log('player ready');
//         //   player.src({
//         //     src: 'https://d39a1jlfqg0udk.cloudfront.net/videos/1Plp2rrZ/nTHrY6EHQNqg_drm.mpd',
//         //     type: 'application/dash+xml'
//         //   });
//           //
//         //   player.play();
//         });
//
//         // player.play();
//         // var formData = new FormData();
//         // formData.append('country',"IN");
//         // formData.append('dob',this.name);
//         // formData.append('email',"one@one.one");
//         // formData.append('gender',"Male");
//         // formData.append('subscribername',"one");
//         // formData.append('vendorid',"2Plp2rrX");
//         // formData.append('vendorkey',"9nSD1YTsEn7ExjQc");
//
//         // var url = "http://vlitetest.mobiotics.com/subscriber/v1/subscriber/subscribe";
//         // var formData = data;
//         // var hurl = window.location.protocol+"//"+url;
//         // var hurl = url;
//         // console.log(data);
//         // var email = data.get('vendoremail');
//         // this.$http.post(hurl,formData).then( function(response){
//         //     //   this.mainloaderStatus = false;
//         //       console.log("Success"+response.data);
//         //       var result = response.data;
//         //       if(result.success){
//         //           console.log("success");
//         //       }else{
//         //           console.log("failed");
//         //       }
//         //   }, function (response) {
//         //
//         //  });
//
//  //        console.log('fffffffffffff');
//  //        var formData = new FormData();
//  //        formData.append('vendorid',"zhmnkkMk");
//  //        formData.append('vendorkey','9N8UK0kClNN6vAdm');
//  //        formData.append('subscribername',"sangee");
//  //        console.log('iiiiiiiiiiiiiiiiiiii');
//  //        let params = '{"vendorid": "zhmnkkMk","vendorkey": "9N8UK0kClNN6vAdm","subscribername": "sangee"}';
//  //
//  //        let urlSearchParams = new URLSearchParams();
//  //       urlSearchParams.append('userId', '2');
//  //       urlSearchParams.append('email', 'p@es.es');
//  //
//      let path = 'http://vlitetest.mobiotics.com/subscriber/v1/subscriber/Zc0jW8sVCVhj';
//      var headers = new Headers();
//        headers.append('Content-Type', 'multipart/form-data');
//  //
//        var data = new FormData()
//        data.append('vendorid',"zhmnkkMk");
//               data.set('vendorkey','9N8UK0kClNN6vAdm');
//               data.set('subscribername',"sangee");
//  // data.set('actual_po_reference', this.actual_po_reference)
//  data.set('_method', 'put')
//
//     //  console.log('[Store actGetSubscribe] params', params);
//
//      this.$http.put(path, data).then(response => {
//        // console.log('[Store actGetSubscribe] response', response);
//
//     //    if (response.ok && response.status === 200) {
//     //      resolve(response.body);
//     //    } else {
//     //      reject({ error: true });
//     //    }
//      }).catch(error => {
//        // console.log('[Store actGetSubscribe] error', error);
//
//     //    reject(error);
//      });
//
//     // let formData ={
//     //     "vendorid": "zhmnkkMk"
//     // };
//     //
//     // console.log(formData);
//     // var formData = new FormData();
//                     // formData.append('title', this.title);
//                     // formData.append('body', this.body);
//                     // this.$http.put(path, formData,{'headers':{'Content-Type': 'application/json'}})
//                     //         .success(function () {
//                     //             // this.modalName.showMod = false;
//                     //             // location.reload();
//                     //         }).error(function (data) {
//                     //             // this.errors.title = data.title;
//                     //             // this.errors.body = data.body;
//                     //             // this.modalName.showMod = true;
//                     //         });
//
//     }
//   }
</script>



// WEBPACK FOOTER //
// src/components/Test.vue